module.exports = __webpack_public_path__ + "img/6.0f9eccb4.png";